export const POC_TYPE = "POC_TYPE";
export const POC_SITE_TYPE = "POC_SITE_TYPE";
export const POC_SUB_SITE_TYPE = "POC_SUB_SITE_TYPE";
export const ALL_CLIENT = "ALL_CLIENT";
export const CLIENT_BUSINESS = "CLIENT_BUSINESS";
export const BUSINESS_DETAILS = "BUSINESS_DETAILS";
